<div class="container-fluid">
  <div class="row">
      <div class="card">
        <div class="col-12" style="display:flex;justify-content: flex-start;">
          <button *ngIf="caseService.case && caseService.case.settings.allowEditCaseFind" class="btn btn-primary m-3" (click)="CraeteCaseFind()">
              <i class="fa fa-plus-circle"></i>
              <span> {{'AddCaseFind' | translate}} </span>
          </button>
        </div>

         
        <div class="col-sm-12">
          <div *ngIf="!showAddPage && !showEditPage" class="card">
            <table class="table table-striped mt-3">
              <thead class="thead-dark">
                <tr>
                  <th>{{ "TypeCaseFind" | translate }}</th>
                  <th>{{ "StatusCaseFind" | translate }}</th>
                  <th>{{ "findOrder" | translate }}</th>
                  <th>{{ "DateCaseFind" | translate }}</th>
                <th>{{ "createDate" | translate }}</th>

                  <th scope="col">{{ "Show" | translate }}</th>
                  <th scope="col" *ngIf="caseService.case && caseService.case.settings.allowEditCaseFind">{{ "Edit" | translate }}</th>
                  <th scope="col" *ngIf="caseService.case && caseService.case.settings.allowEditCaseFind">{{ "Delete" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let find of CaseFindArr">
                  <td>{{ find.findTypeName }}</td>
                  <td>{{ find.findStatusName }}</td>
                  <td>{{ find.findOrder  }}</td>
                  <td>{{ find.dateOfFind  | toDateLarge  }}</td>
                  <td>{{ find.createdOn | toDateOnly }}

                    <br />
                         
                    <span  *ngIf="find.creatorName!=null" style="font-size: 10px; ">{{'companyandBy'|translate}}:{{
                      find.creatorName}}</span>
                    
                  </td>
                  <td>
                    <a (click)="editCaseFind(find,ShowCaseFind)" href="javascript:void(0);">
                        <i class="fa fa-eye"></i>
                    </a>
                </td>
                  <td *ngIf="caseService.case && caseService.case.settings.allowEditCaseFind">
                    <a (click)="editCaseFind(find)" href="javascript:void(0);">
                      <i class="fa fa-edit"></i>
                    </a>
                  </td>
                  <td *ngIf="caseService.case && caseService.case.settings.allowEditCaseFind">
                    <a (click)="deleteCaseFind(find.caseFindId, deleteModal)" href="javascript:void(0);">
                      <i class="fa fa-trash"></i>

                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="showAddPage || showEditPage" class="card p-3">
            <h4 *ngIf="isInsert">
              {{ "AddCaseFind" | translate }}
            </h4>
            <h4 *ngIf="!isInsert">
              {{ "EditCaseFind" | translate }}
            </h4>
            <div class="form-group row mt-3">
              <div class="col-lg-6">
            
                  <label>{{ "TypeCaseFind" | translate }}</label>
                  <span *ngIf="TypeCaseFind.invalid" class="alert" style="color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;">
                      <span *ngIf="TypeCaseFind.errors?.required">*</span>
                  </span>
                <ng-select id="TypeCaseFind" required #TypeCaseFind="ngModel" class="form-control-select"
                  [items]="TypeCaseFindArr" bindLabel="text" bindValue="id" [(ngModel)]="findtypeId"
                  [ngModelOptions]="{ standalone: true }" placeholder="{{ 'TypeCaseFind' | translate }}">
                </ng-select>
              </div>
              <div class="col-lg-6" *ngIf="findtypeId==5">
                <label for="Other"> {{'otherCaseFind' | translate}} </label>
                <input #Other="ngModel" name="Other" id="Other"
                    [(ngModel)]="other" type="text" class="form-control"
                    placeholder="{{ 'otherCaseFind' | translate }}" />
  
            </div>
              <div class="col-lg-6">
               
                  <label>{{ "StatusCaseFind" | translate }}</label>
                  <span *ngIf="StatusCaseFind.invalid" class="alert" style="color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;">
                      <span *ngIf="StatusCaseFind.errors?.required">*</span>
                  </span>
                <ng-select id="StatusCaseFind" required #StatusCaseFind="ngModel" class="form-control-select"
                  [items]="findstatusArr" bindLabel="text" bindValue="id" [(ngModel)]="findstatusId"
                  [ngModelOptions]="{ standalone: true }" placeholder="{{ 'StatusCaseFind' | translate }}">
                </ng-select>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div *ngIf="isInsert" class="col-lg-6">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label> {{ "DateCaseFind" | translate }}</label>
                  <span *ngIf="!dateOfFind" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                    *
                  </span>
                </div>
                <datepicker [(maxHijri)]="currentDate" [(maxGreg)]="currentDate" [(selectedDate)]="currentDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2"></datepicker>
              </div>
              <div *ngIf="!isInsert" class="col-lg-6">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label> {{ "DateCaseFind" | translate }}</label>
                  <span *ngIf="!dateOfFind" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                    *
                  </span>
                </div>
                <datepicker [(maxHijri)]="currentDate"  [(maxGreg)]="currentDate" [(selectedDate)]="editedDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2"></datepicker>
              </div>
              <div class="col-lg-6">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label> {{ "findOrder" | translate }}</label>
                  <span *ngIf="Order.invalid" class="alert" style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                ">
                      <span *ngIf="Order.errors?.required">*</span>
                  </span>
                </div>
                <input #Order="ngModel" name="Order" id="Order" (keypress)="numberOnly($event)" [(ngModel)]="findOrder" type="text" class="form-control"
                  placeholder="{{ 'findOrder' | translate }}" required />
              </div>
  
  
            </div>
            <div class="row" style="justify-content: center;">
              <button *ngIf="isInsert"  [disabled]="TypeCaseFind.invalid || StatusCaseFind.invalid || !dateOfFind || Order.invalid" (click)="OnCraeteCaseFind()" style="color: black; font-weight: bold" type="button"
                class="btn btn-primary col-lg-3 m-1" >
                {{ "Save and Back" | translate }}
              </button>
              <button *ngIf="!isInsert" [disabled]="TypeCaseFind.invalid || StatusCaseFind.invalid || !dateOfFind || Order.invalid" (click)="OnEditCaseFind()" style="color: black; font-weight: bold" type="button"
                class="btn btn-primary col-lg-3 m-1" >
                {{ "Save and Back" | translate }}
              </button>
              <button type="button" class="btn btn-danger col-lg-3 m-1" (click)="showAddPage=false; showEditPage=false;">
                {{ "BackLists" | translate }}
              </button>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </div>



<ng-template #ShowCaseFind let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Show" | translate }}
    </h4>
  
    <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
  </div>
  <div class="modal-body">
    <div class="custom-form">
      <div class="col-12 offset-1">
        <div class="card p-3">
          <div class="form-group row">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "TypeCaseFind" | translate }}</label>
              </div>
 
              <input #TypeCaseFind="ngModel" name="TypeCaseFind" id="TypeCaseFind" [(ngModel)]="findTypeName" type="text" class="form-control"
              placeholder="{{ 'TypeCaseFind' | translate }}" readonly />
           
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "StatusCaseFind" | translate }}</label>
              </div>
              <input #StatusCaseFind="ngModel" name="StatusCaseFind" id="StatusCaseFind" [(ngModel)]="findStatusName" type="text" class="form-control"
              placeholder="{{ 'StatusCaseFind' | translate }}" readonly />
            </div>
          </div>
          <div class="form-group row mt-3">
             
            <div  class="col-lg-9 m-2">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label> {{ "DateCaseFind" | translate }}</label>
              </div>
              <input #DateCaseFind="ngModel" name="DateCaseFind" id="DateCaseFind" [ngModel]="dateOfFind | toDateOnly " type="text" class="form-control"
              placeholder="{{ 'DateCaseFind' | translate }}" readonly />
          
              <!-- <datepicker [(selectedDate)]="editedDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2"></datepicker> -->
            </div>
            <div class="col-lg-9">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label> {{ "findOrder" | translate }}</label>
              </div>
              <input #Order="ngModel" name="Order" id="Order" [(ngModel)]="findOrder" type="text" class="form-control"
                placeholder="{{ 'findOrder' | translate }}" readonly />
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer row" style="justify-content: space-between; padding: 1rem 2rem">
    <div class="col-lg-3"></div>
    
    <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
  <div class="modal-header" style="justify-content: center">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "ConfirmDeleteOperation" | translate }}
    </h4>
  </div>
  <div class="modal-body text-center">
    <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="onDeleteCaseFind(modal)">
      {{ "YES" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
      {{ "NO" | translate }}
    </button>
  </div>
</ng-template>